import React from 'react';
import { MapPin, Phone, Mail, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 px-4 border-t border-slate-800" data-id="element-27">
      <div className="max-w-7xl mx-auto" data-id="element-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-29">
          {/* Company Info */}
          <div className="space-y-4" data-id="element-30">
            <div className="mb-6" data-id="element-31">
              <img src="https://cdn.magicpatterns.com/uploads/qa84VP1fEhJxAxqz3KkeSm/logo.png" alt="A-Flow Seamless Rain Gutters" className="h-10 w-auto brightness-0 invert" data-id="element-32" />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-33">
              Providing top-quality seamless aluminum and copper rain gutters
              for residential and commercial properties in Southern California.
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-slate-800 rounded-md text-sm font-medium text-slate-200 border border-slate-700" data-id="element-34">
              <ShieldCheck className="w-4 h-4 text-[#b87333]" data-id="element-35" />
              Licensed & Insured
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-36">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-37">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-38">
              {[{
              name: 'Home',
              href: '/'
            }, {
              name: 'About Us',
              href: '/about'
            }, {
              name: 'Services',
              href: '/services'
            }, {
              name: 'Appointment Request',
              href: '/appointment'
            }, {
              name: 'Contact Us',
              href: '/contact'
            }].map(link => <li key={link.name} data-id="element-39">
                  <Link to={link.href} className="text-slate-400 hover:text-[#b87333] transition-colors text-sm flex items-center gap-2" data-id="element-40">
                    <span className="w-1 h-1 bg-slate-600 rounded-full" data-id="element-41" />
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-42">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-43">
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-44">
              <li className="text-slate-400 text-sm" data-id="element-45">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-46">
                  Seamless Rain Gutters
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-47">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-48">
                  Copper Gutters
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-49">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-50">
                  Gutter Guards
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-51">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-52">
                  Gutter Repair
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-53">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-54">
                  Maintenance & Cleaning
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-55">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-56">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-57">
              <li className="flex items-start gap-3 text-sm text-slate-400" data-id="element-58">
                <MapPin className="w-5 h-5 text-[#b87333] shrink-0 mt-0.5" data-id="element-59" />
                <span data-id="element-60">
                  Orange County, CA
                  <br data-id="element-61" />
                  Serving Southern California
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-400" data-id="element-62">
                <Phone className="w-5 h-5 text-[#b87333] shrink-0" data-id="element-63" />
                <a href="tel:7146023634" className="hover:text-white transition-colors" data-id="element-64">
                  (714) 602-3634
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-400" data-id="element-65">
                <Mail className="w-5 h-5 text-[#b87333] shrink-0" data-id="element-66" />
                <a href="mailto:info@aflowraingutters.com" className="hover:text-white transition-colors" data-id="element-67">
                  info@aflowraingutters.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500" data-id="element-68">
          <p data-id="element-69">
            © {new Date().getFullYear()} A-Flow Seamless Rain Gutters. All
            rights reserved.
          </p>
          <div className="flex gap-4" data-id="element-70">
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-71">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-72">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}